import { callApi } from "./fetchTools";
import { HTTP_METHOD_GET } from "../utils/constant";
import apis from "../common/apis";
import { IResponse } from "../models/base";
import { IVoucherInfo } from "../models/interface/IVoucherInfo";

export default {
  getVoucher: (code: string) => {
    const path = apis.voucher_code.replace("{voucher_code}", code);
    return callApi<IResponse<IVoucherInfo>>(HTTP_METHOD_GET, path, null);
  },
};
